import Vue from "vue";
const ctx = require.context("./", false, /.+\.directive\.js$/);
const nameRe = /\.\/(.+)\.directive\.js$/;

ctx.keys().forEach(path => {
    const definition = ctx(path).default;
    const name = nameRe.exec(path)[1];

    Vue.directive(name, definition);
});



// WEBPACK FOOTER //
// ./src/directives/index.js